import React from 'react';
import PlacementCard from './PlacementCard';

const PlacementHighlightBanner = () => {
  return (
    <section className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-4 py-16 text-center">
      {/* Top highlight section */}
      <PlacementCard />

      {/* Bottom CTA */}
      <h2 className="font-manrope text-[20px] md:text-[44px] md:font-extrabold md:leading-[66px]">
        2500+ Learners Placed In Top Companies
      </h2>
    </section>
  );
};

export default PlacementHighlightBanner;
